// DevRev Configuration - Hardcoded for production and development
const AAT = 'eyJhbGciOiJSUzI1NiIsImlzcyI6Imh0dHBzOi8vYXV0aC10b2tlbi5kZXZyZXYuYWkvIiwia2lkIjoic3RzX2tpZF9yc2EiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOlsiamFudXMiXSwiYXpwIjoiZG9uOmlkZW50aXR5OmR2cnYtaW4tMTpkZXZvLzJWYzNYU3prWVk6ZGV2dS8xIiwiZXhwIjoxNzk4NzI1NjAyLCJodHRwOi8vZGV2cmV2LmFpL2NsaWVudGlkIjoiZG9uOmlkZW50aXR5OmR2cnYtaW4tMTpkZXZvLzJWYzNYU3prWVk6c3ZjYWNjLzc3IiwiaHR0cDovL2RldnJldi5haS9kZXZvX2RvbiI6ImRvbjppZGVudGl0eTpkdnJ2LWluLTE6ZGV2by8yVmMzWFN6a1lZIiwiaHR0cDovL2RldnJldi5haS9kZXZvaWQiOiJERVYtMlZjM1hTemtZWSIsImh0dHA6Ly9kZXZyZXYuYWkvc3ZjYWNjIjoiZG9uOmlkZW50aXR5OmR2cnYtaW4tMTpkZXZvLzJWYzNYU3prWVk6c3ZjYWNjLzc3IiwiaHR0cDovL2RldnJldi5haS90b2tlbnR5cGUiOiJ1cm46ZGV2cmV2OnBhcmFtczpvYXV0aDp0b2tlbi10eXBlOmFhdCIsImlhdCI6MTc2NTQ2MTYwMiwiaXNzIjoiaHR0cHM6Ly9hdXRoLXRva2VuLmRldnJldi5haS8iLCJqdGkiOiJkb246aWRlbnRpdHk6ZHZydi1pbi0xOmRldm8vMlZjM1hTemtZWTp0b2tlbi9xdXNnQmh5aSIsInNjb3BlIjoidXJuOmRldnJldjpwYXJhbXM6b2F1dGg6dG9rZW4tdHlwZTpzZXNzaW9uOnJldiIsInN1YiI6ImRvbjppZGVudGl0eTpkdnJ2LWluLTE6ZGV2by8yVmMzWFN6a1lZOnN2Y2FjYy83NyJ9.o2i8ADzfS84ge_n-RWw97qK0qYkKiviGitmAjCI1u2RNvz7DOA-qUGlgxH65FndpcVEBpdwF1ue6O9a4aLxi67RVthvis6Fi85Ok5aF48SxmNalGizTILo2v6HdjNq_VBsshcpbF19Eieoi8DBXGENBcwfgIIsHsOiUzgZ8-Ztqnku6abbPkx5_ODKsBp9P1sJ9jnj1LDllouC24cf8XnmNl_Joag4pMHCOzM4bUHCFSwFgDU4IY2hvck5yUy7XUJXQqzJR9VPsgsZ_8xwqjbD5-rYSljgPGHigoiMCnKHH83UfTuQvk5kOd_hTSsZim6nUw5IQUgsgcoUyki9hx9w'
const APP_ID = 'DvRvStPZG9uOmNvcmU6ZHZydi1pbi0xOmRldm8vMlZjM1hTemtZWTpwbHVnX3NldHRpbmcvMV9ffHxfXzIwMjUtMDgtMjEgMTQ6NDE6NDguMTU2MDI0NDQ0ICswMDAwIFVUQw==xlxendsDvRv'

export const DEVREV_CONFIG = {
  // Application Access Token (AAT) - Hardcoded
  AAT,
  
  // Application ID - Hardcoded
  APP_ID,
  
  // API Base URL
  API_BASE_URL: 'https://api.devrev.ai',
  
  // Session token endpoint
  SESSION_TOKEN_ENDPOINT: '/auth-tokens.create',
  
  // Account and Workspace Configuration
  ACCOUNT_REF: 'yourinsurance.app',
  WORKSPACE_REF: 'YourInsurance',
  
  // Default configuration
  DEFAULT_CONFIG: {
    enable_default_launcher: true,
    widget_alignment: 'right',
    spacing: {
      bottom: '20px',
      side: '20px'
    }
  }
}

// DevRev API Service
export class DevRevService {
  constructor() {
    this.config = DEVREV_CONFIG
    this.widgetReady = false
    this.readyPromise = null
  }

  // Generate session token for user
  async generateSessionToken(userEmail, userDisplayName = null) {
    try {
      const payload = {
        rev_info: {
          user_ref: userEmail,
          user_traits: {
            email: userEmail,
            display_name: userDisplayName || userEmail,
            phone_numbers: []
          }
        }
      }

      const response = await fetch(`${this.config.API_BASE_URL}${this.config.SESSION_TOKEN_ENDPOINT}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.config.AAT}`, // Fixed: Added Bearer prefix
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })

      if (response.ok) {
        const data = await response.json()
        const sessionToken = data.access_token || data.token || data.session_token

        if (sessionToken) {
          return {
            success: true,
            session_token: sessionToken,
            expires_at: Date.now() + (3600 * 1000) // 1 hour from now
          }
        } else {
          return {
            success: false,
            error: 'Session token not found in API response',
            details: data
          }
        }
      } else {
        let errorData
        try {
          errorData = await response.json()
        } catch (e) {
          const textError = await response.text()
          return { success: false, error: `API returned ${response.status}: ${textError}` }
        }
        return {
          success: false,
          error: errorData.message || errorData.error || errorData.detail || `Failed (${response.status})`
        }
      }
    } catch (error) {
      return { success: false, error: error.message }
    }
  }

  // Initialize PLuG widget
  initializeWidget(sessionToken = null, customLauncherSelector = null) {
    if (typeof window === 'undefined' || !window.plugSDK) {
      console.error('PLuG SDK not available')
      return false
    }

    try {
      const config = {
        app_id: this.config.APP_ID,
        enable_default_launcher: false,
        custom_launcher_selector: customLauncherSelector || '#devrev-chat-launcher',
        widget_alignment: 'right',
        spacing: {
          bottom: '20px',
          side: '20px'
        }
      }

      // Add session token if provided
      if (sessionToken) {
        config.session_token = sessionToken
      }

      window.plugSDK.init(config)
      
      // Set up event listeners
      this.setupEventListeners()
      
      return true
    } catch (error) {
      console.error('Error initializing PLuG widget:', error)
      return false
    }
  }

  // Set up PLuG event listeners
  setupEventListeners() {
    if (!window.plugSDK) return

    // Create a promise that resolves when widget is ready
    if (!this.readyPromise) {
      this.readyPromise = new Promise((resolve) => {
        this.resolveReady = resolve
      })
    }

    window.plugSDK.onEvent((payload) => {
      console.log('PLuG Event:', payload.type)
      
      if (payload.type === 'ON_PLUG_WIDGET_READY') {
        console.log('✅ PLuG widget ready')
        this.widgetReady = true
        if (this.resolveReady) {
          this.resolveReady()
        }
        this.onWidgetReady()
      }
    })
  }

  // Handle widget ready event
  onWidgetReady() {
    // Enable chat launcher button
    const launcher = document.getElementById('devrev-chat-launcher')
    if (launcher) {
      launcher.style.opacity = '1'
      launcher.disabled = false
    }
  }

  // Reset and reinitialize widget with explicit positioning
  resetWidget() {
    if (typeof window === 'undefined' || !window.plugSDK) {
      console.error('PLuG SDK not available')
      return false
    }

    try {
      // Close any open widget first
      window.plugSDK.toggleWidget(false)
      
      // Reinitialize with explicit positioning (like PetStore)
      const config = {
        app_id: this.config.APP_ID,
        enable_default_launcher: false,
        custom_launcher_selector: '#devrev-chat-launcher',
        widget_alignment: 'right',
        spacing: {
          bottom: '20px',
          side: '20px'
        }
      }

      window.plugSDK.init(config)
      console.log('✅ Widget reset with explicit positioning (right side)')
      return true
    } catch (error) {
      console.error('Error resetting PLuG widget:', error)
      return false
    }
  }

  // Open chat with specific context
  async openChat(context = null) {
    if (!window.plugSDK) {
      console.error('PLuG SDK not available')
      return false
    }

    try {
      // Wait for widget to be ready
      if (!this.widgetReady) {
        console.log('⏳ Waiting for widget to be ready...')
        if (this.readyPromise) {
          await this.readyPromise
          console.log('✅ Widget is now ready')
        } else {
          // If no ready promise, wait a bit and try
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
      }

      if (context) {
        window.plugSDK.toggleWidget(true, 'create_conversation', {
          startConversationContent: context
        })
      } else {
        window.plugSDK.toggleWidget(true)
      }
      return true
    } catch (error) {
      console.error('Error opening PLuG chat:', error)
      return false
    }
  }
}

// Export singleton instance
export const devRevService = new DevRevService()
